module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-margin middle-xs center-xs col-xs-3",
    attrs: {
      "id": "teacher-quote"
    }
  }, [_c('div', {
    staticClass: "quoted-item"
  }, [_c('p', {
    staticClass: "col-xs-12 start-xs pl-subheading italics",
    staticStyle: {
      "margin": "15px 40px"
    }
  }, [_vm._v("\n      \"" + _vm._s(_vm.quote) + "\"\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row no-margin center-xs middle-xs"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/day_nick.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "start-xs pl-title",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.school) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-66c541ea!./src/app/features/authentication/components/teacherQuotes/teacherQuotes.template.html
// module id = 2342
// module chunks = 61